import React from 'react';
import styled, { css } from '../references';

export const fontFamilyStylesObject: React.CSSProperties = {
  fontFamily: '"proxima-nova", "helvetica", "arial", sans-serif',
};

export const fontFamilyStyles = css`
  font-family: 'proxima-nova', 'helvetica', 'arial', sans-serif;
`;

export const RowStyles = css`
  display: flex;
  flex-direction: row;
`;

export const RowReverseStyles = css`
  display: flex;
  flex-direction: row-reverse;
`;

export const StretchRowStyles = css`
  ${RowStyles};
  justify-content: space-between;
`;

export const ColumnStyles = css`
  display: flex;
  flex-direction: column;
`;

export const CenterColumnStyles = css`
  ${ColumnStyles};
  align-items: center;
`;

export const InlineStyles = css`
  display: inline;
`;

export const StretchColumnStyles = css`
  ${ColumnStyles};
  justify-content: space-between;
`;

export const RowReverse = styled.div`
  ${RowReverseStyles}
`;

export const StretchRowReverse = styled.div`
  ${RowReverseStyles}
  justify-content: space-between;
`;

export const Row = styled.div`
  ${RowStyles};
`;

export const StretchRow = styled.div`
  ${StretchRowStyles};
`;

export const CenterRow = styled.div`
  ${RowStyles};
  justify-content: center;
`;

export const Relative = styled.div`
  position: relative;
`;

export const Column = styled.div`
  ${ColumnStyles};
`;

export const CenterColumn = styled.div`
  ${CenterColumnStyles};
  align-self: center;
`;

export const Contents = styled.div`
  display: contents;
`;

export const Column100PercentHeight = styled(Column)`
  height: 100%;
`;

export const Column100PercentWidth = styled(Column)`
  width: 100%;
`;

export const ColumnCentered = styled(Column)`
  align-items: center;
  justify-content: center;
`;

export const StretchColumn = styled.div`
  ${StretchColumnStyles};
`;

export const Inline = styled.div`
  ${InlineStyles};
`;

export const Div = styled.div``;

export const Span = styled.span``;

export const Anchor = styled.a``;

// example default styles for a component
export const codeEnhancer = css`
  background: ${props => props.theme.colors.backgroundActive};
  border: 1px solid ${props => props.theme.colors.border};
  color: ${props => props.theme.colors.foregroundActive};
  flex-direction: column;
  font-family: monospace;
  overflow: auto;
  padding: 1em;
  white-space: pre;
`;

export const Code = styled(Column)`
  ${codeEnhancer};
`;

export const Absolute = styled.div<{
  top?: string;
  right?: string;
  bottom?: string;
  left?: string;
}>`
  position: absolute;
  top: ${props => props.top ?? 'auto'};
  right: ${props => props.right ?? 'auto'};
  bottom: ${props => props.bottom ?? 'auto'};
  left: ${props => props.left ?? 'auto'};
`;
